var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-wrapper" },
    [
      _vm._t("before"),
      _vm._v(" "),
      _c("input", {
        staticStyle: { display: "none" },
        attrs: { fake_pass: "", type: "password" }
      }),
      _vm._v(" "),
      _vm.type === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value,
                expression: "value"
              }
            ],
            attrs: {
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              autocomplete: "false",
              step: _vm.step,
              type: "checkbox"
            },
            domProps: {
              checked: Array.isArray(_vm.value)
                ? _vm._i(_vm.value, null) > -1
                : _vm.value
            },
            on: {
              input: function($event) {
                $event.preventDefault()
                return _vm.update($event)
              },
              blur: _vm._blur,
              focus: _vm._focus,
              change: function($event) {
                var $$a = _vm.value,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.value = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.value = $$c
                }
              }
            }
          })
        : _vm.type === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value,
                expression: "value"
              }
            ],
            attrs: {
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              autocomplete: "false",
              step: _vm.step,
              type: "radio"
            },
            domProps: { checked: _vm._q(_vm.value, null) },
            on: {
              input: function($event) {
                $event.preventDefault()
                return _vm.update($event)
              },
              blur: _vm._blur,
              focus: _vm._focus,
              change: function($event) {
                _vm.value = null
              }
            }
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value,
                expression: "value"
              }
            ],
            attrs: {
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              autocomplete: "false",
              step: _vm.step,
              type: _vm.type
            },
            domProps: { value: _vm.value },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.value = $event.target.value
                },
                function($event) {
                  $event.preventDefault()
                  return _vm.update($event)
                }
              ],
              blur: _vm._blur,
              focus: _vm._focus
            }
          }),
      _vm._v(" "),
      _vm._t("after")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }